import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';

const Destinos = ({ lang, destinos, ruta }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <>
            <section className="u-clearfix u-white u-section-2" id="block-4">
                <div className="u-clearfix u-sheet u-valign-middle u-sheet-1">
                    <h2 className="u-align-center u-custom-font u-font-oswald u-text u-text-1" data-animation-name="customAnimationIn" data-animation-duration="500" data-animation-out="0">{t("Destinos")}</h2>
                </div>
            </section>
            <section className="u-clearfix u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xs u-white u-section-3" id="block-3">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-sheet-1">
                    <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-20 u-layout-wrap u-layout-wrap-1">
                        <div className="u-gutter-0 u-layout">
                            <div className="u-layout-col">
                                <div className="u-container-align-center u-container-style u-image u-image-default u-layout-cell u-size-60 u-image-1" data-animation-name="customAnimationIn" data-animation-duration="500" data-animation-delay="0" data-animation-out="0" data-image-width="1558" data-image-height="854">
                                    <div className="u-container-layout u-container-layout-1"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="u-align-center u-clearfix u-container-align-center u-white u-section-4" id="sec-f984">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-sheet-1">
                    <div className="u-expanded-width u-list u-list-1">
                        <div className="u-repeater u-repeater-1">
                            {destinos.map((undestino, index) => (
                                <Fragment key={"dest-" + index}>
                                    {undestino.querutas.length > 0 ?
                                        <div className="u-align-left u-container-align-left u-container-style u-custom-item u-effect-hover-zoom u-image-default u-list-item u-repeater-item u-list-item-1" data-image-width="1414" data-image-height="2000" data-animation-out="0" data-href={"/" + preidioma + t("embarcaciones") + "-" + undestino.laurl} title={undestino.elnombre} key={index}>
                                            <div className="u-background-effect u-expanded">
                                                <div className="u-background-effect-image u-expanded u-image u-shading u-image-1"
                                                    style={{
                                                        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(/images/web/onboard2/dest${undestino.id}.jpg`
                                                    }}
                                                ></div>
                                            </div>
                                            <div className="u-container-layout u-similar-container u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xs u-container-layout-1">
                                                <h3 className="u-align-left u-text u-text-white u-text-1">{undestino.elnombre.toUpperCase()}</h3>
                                                <p className="u-custom-item u-text u-text-body-alt-color u-text-2">
                                                    {undestino.querutas.map((unaruta, index2) => (
                                                        <Fragment key={"ruta-" + index + "-" + index2}>
                                                            {(index2 > 0) ? <br /> : ""}&gt; <a style={{ color: "#FFF" }} href={"/" + preidioma + t("embarcaciones") + "-" + undestino.laurl + "#ruta" + (index2 + 1)}>{unaruta.nombre}</a>
                                                        </Fragment>
                                                    ))}
                                                </p>
                                            </div>
                                        </div>
                                        :
                                        <div className="u-align-left u-container-align-left u-container-style u-custom-item u-effect-hover-zoom u-image-default u-list-item u-repeater-item u-list-item-7" data-image-width="1414" data-image-height="2000" data-animation-out="0" data-href={"/" + preidioma + t("embarcaciones") + "-" + undestino.laurl} title={undestino.elnombre}>
                                            <div className="u-background-effect u-expanded">
                                                <div className="u-background-effect-image u-expanded u-image u-shading u-image-7"
                                                    style={{
                                                        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(/images/web/onboard2/dest${undestino.id}.jpg`
                                                    }}
                                                ></div>
                                            </div>
                                            <div className="u-container-layout u-similar-container u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xs u-container-layout-7">
                                                <h3 className="u-align-left u-text u-text-white u-text-13">{undestino.elnombre.toUpperCase()}</h3>
                                                <p className="u-custom-item u-text u-text-body-alt-color u-text-14">&gt; {t("Descubre")}</p>
                                            </div>
                                        </div>
                                    }
                                </Fragment>
                            ))}
                            {(destinos.length % 4 != 0) ?
                                <div className="u-align-left u-container-align-left u-container-style u-custom-item u-effect-hover-zoom u-image-default u-list-item u-repeater-item u-list-item-8" data-image-width="1414" data-image-height="2000" data-animation-out="0">
                                    <div className="u-background-effect u-expanded">
                                        <div className="u-background-effect-image u-expanded u-image u-shading u-image-8"
                                            style={{
                                                backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(/images/web/onboard2/dest0.jpg`
                                            }}
                                        ></div>
                                    </div>
                                    <div className="u-container-layout u-similar-container u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xs u-container-layout-8">
                                        <h3 className="u-align-left u-text u-text-white u-text-15">. </h3>
                                        <p className="u-custom-item u-text u-text-body-alt-color u-text-16"> &gt; {t("Estamos trabajando continuamente en nuevos destinos para ti")}</p>
                                    </div>
                                </div>
                                :
                                ""
                            }
                        </div>
                    </div>
                </div>
            </section >
        </>
    );
}

export default Destinos;
